import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'overview-detail',
  templateUrl: './overview-detail.component.html',
  styleUrls: ['./overview-detail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverviewDetailComponent {}
